import axios from 'axios';
import config from '@assets/config.json'; // api 请求json 

const state = {
}
const mutations = {
}
const getters = {
}
const actions = {
  getBanner({ rootState, commit }, opt) {
    // 获取活动信息
    // 0：HomeTop = 首页顶部
    // 1：Style = 企业风采
    // 2：图集（多张）
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/CompanyBanner/GetByType?compId=${opt.compId}&typeid=${opt.type}&show=0`, rootState.header).then(data => {
        if (data.data && Array.isArray(data.data)) { 
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  addBanner({ rootState }, opt) { // 添加活动信息
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/CompanyBanner`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  delBanner({ rootState }, id) { // 删除活动信息
    return new Promise((resolve, reject) => {
      axios.delete(`${config.api.reqApi}/api/CompanyBanner?id=${id}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  editBanner({ rootState }, opt) { // 修改活动信息
    return new Promise((resolve, reject) => {
      axios.put(`${config.api.reqApi}/api/CompanyBanner`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
} 